export default __webpack_public_path__ + "static/media/outdoor_good.86ba51d1.jpg";